import { RootState } from "@store/index";
import { ManageContactsState } from "./models";

export const contactsSelector = (state: RootState): ManageContactsState["contacts"] => state.manageContacts.contacts;

export const editSelector = (state: RootState): ManageContactsState["edit"] => state.manageContacts.edit;
